import Vue from 'vue'
import VueRouter from 'vue-router'
import { Message } from 'element-ui'
import ApiService from '@/utils/api.js'
// import HomeView from '../views/HomeView.vue'
import layout from "../components/layout/index.vue";
import pageView from "../components/layout/pageView.vue";
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)
export const menuRoutes = [{
        path: "/welcome",
        name: "welcome",
        meta: {
            title: '首页',
            icon: 'el-icon-house',
            menuType: 'default'
        },
        component: () =>
            import("../views/Welcome.vue"),
    },    {
        path: "/home",
        name: "home",
        meta: {
            title: '发起的报名',
            icon: 'el-icon-files',
            menuType: 'default'
        },
        component: () =>
            import("../views/HomeView.vue"),
    },
    {
        path: "/home/additionalItems",
        name: "additionalItems",
        meta: {
            title: '报名项目详情',
            icon: 'el-icon-s-home',
            menuType: 'hidden' // 隐藏菜单，不在左侧显示
        },
        component: () =>
            import("../views/AdditionalItems.vue"),
    },
    {
        path: "/home/tournament",
        name: "tournament",
        meta: {
            title: '比赛对阵',
            icon: 'el-icon-trophy',
            menuType: 'hidden' // 隐藏菜单，不在左侧显示
        },
        component: () =>
            import("../views/Tournament.vue"),
    },{
        path: "/orders",
        name: "orders",
        meta: {
            title: '报名记录',
            icon: 'el-icon-document-checked',
            menuType: 'default'
        },
        component: () =>
            import("../views/Orders.vue"),
    },{
        path: "/feedback",
        name: "feedback",
        meta: {
            title: '功能反馈',
            icon: 'el-icon-headset',
            menuType: 'default'
        },
        component: () =>
            import("../views/Feedback.vue"),
    },{
        path: "/products",
        name: "products",
        meta: {
            title: '商品管理',
            icon: 'el-icon-goods',
            menuType: 'product'
        },
        component: () =>
            import("../views/Product.vue"),
    },{
        path: "/store",
        name: "store",
        meta: {
            title: '店铺功能',
            icon: 'el-icon-shopping-cart-2',
            menuType: 'store'
        },
        component: pageView,
        children: [{
            path: "/store/orders",
            name: "storeOrders",
            meta: {
                title: '店铺订单',
                icon: 'el-icon-s-home',
                menuType: 'store'
            },
            component: () =>
                import("../views/storeOrders.vue"),
        }]
    },{
        path: "/about",
        name: "about",
        meta: {
            title: '关于我们',
            icon: 'el-icon-s-home',
            menuType: 'hidden'
        },
        component: () =>
            import("../views/AboutView.vue"),
    },
    {
        path: "/logistics",
        name: "logistics",
        meta: {
            title: '物流管理',
            icon: 'el-icon-s-home',
            menuType: 'hidden'
        },
        component: () =>
            import("../views/Logistics.vue"),
    },
    {
        path: "/set",
        name: "set",
        meta: {
            title: '设置',
            icon: 'el-icon-s-home',
            menuType: 'hidden'
        },
        component: () =>
            import("../views/SetUp.vue"),
    },
    {
        path: "/signUp",
        name: "signUp",
        meta: {
            title: '报名管理',
            icon: 'el-icon-s-home',
            menuType: 'hidden'
        },
        component: () =>
            import("../views/SignUp.vue"),
    },
    {
        path: "/management",
        name: "management",
        meta: {
            title: '管理菜单',
            icon: 'el-icon-s-home',
            menuType: 'hidden'
        },
        component: pageView,
        children: [{
            path: "/management/createMenu",
            name: "createMenu",
            meta: {
                title: '创建菜单',
                icon: 'el-icon-s-home',
                menuType: 'hidden'
            },
            component: () =>
                import("../views/AddManagement.vue"),
        }, {
            path: "/management/editMenu",
            name: "editMenu",
            meta: {
                title: '编辑菜单',
                icon: 'el-icon-s-home',
                menuType: 'hidden'
            },
            component: () =>
                import("../views/EditManagement.vue"),
        }]
    },
    {
        path: "/system",
        name: "system",
        meta: {
            title: "系统管理",
            icon: "el-icon-cpu",
            menuType: 'system',
            requireAdmin: true
        },
        component: pageView,
        children: [{
            path: "/system/todos",
            name: "systemTodos",
            meta: {
                title: "系统工具",
                icon: "el-icon-s-home",
                menuType: 'system',
                requireAdmin: true
            },
            component: () =>
                import("../views/systemTodos.vue"),
        },
        {
            path: "/system/stat",
            name: "systemStat",
            meta: {
                title: "统计数据",
                icon: "el-icon-s-home",
                menuType: 'system',
                requireAdmin: true
            },
            component: () =>
                import("../views/systemStat.vue"),
        },
        {
            path: "/system/dayStat",
            name: "systemDayStat",
            meta: {
                title: "分日详情数据",
                icon: "el-icon-s-home",
                menuType: 'system',
                requireAdmin: true
            },
            component: () =>
                import("../views/systemDayStat.vue"),
        },
        {
            path: "/system/activityUvRank",
            name: "systemActivityUvRank",
            meta: {
                title: "活动访问量",
                icon: "el-icon-data-line",
                menuType: 'system',
                requireAdmin: true
            },
            component: () =>
                import("../views/systemActivityUvRank.vue"),
        },
        {
            path: "/system/events",
            name: "systemEvents",
            meta: {
                title: "活动管理",
                icon: "el-icon-tickets",
                menuType: 'system',
                requireAdmin: true
            },
            component: () =>
                import("../views/systemEvents.vue"),
        },
        {
            path: "/system/users",
            name: "systemUsers",
            meta: {
                title: "用户管理",
                icon: "el-icon-user",
                menuType: 'system',
                requireAdmin: true
            },
            component: () =>
                import("../views/systemUsers.vue"),
        },
        {
            path: "/system/orgs",
            name: "systemOrgs",
            meta: {
                title: "组织管理",
                icon: "el-icon-s-home",
                menuType: 'system',
                requireAdmin: true
            },
            component: () =>
                import("../views/systemOrgs.vue"),
        },
        {
            path: "/system/apiTest",
            name: "systemApiTest",
            meta: {
                title: "接口调试",
                icon: "el-icon-connection",
                menuType: 'system',
                requireAdmin: true
            },
            component: () =>
                import("../views/ApiTest.vue"),
        }]
    },
    {
        path: "/minapp",
        name: "minapp",
        meta: {
            title: "独立小程序",
            icon: "el-icon-mobile-phone",
            menuType: 'minapp'
        },
        component: pageView,
        children: [{
            path: "/minapp/setting",
            name: "minappSetting",
            meta: {
                title: "小程序设置",
                icon: "el-icon-setting",
                menuType: 'minapp'
            },
            component: () =>
                import("../views/minappSetting.vue"),
        }]
    },{
        path: "/stat",
        name: "stat",
        meta: {
            title:"数据统计",
            icon:"el-icon-data-analysis",
            menuType: 'stat'
        },
        component: pageView,
        children: [{
            path: "/stat/month",
            name: "statMonth",
            meta: {
                title: "项目月报",
                icon: "el-icon-data",
                menuType: 'stat'
            },
            component: () =>
                import("../views/stat/month.vue"),
        }]
    },
    {
        path: "/fans",
        name: "fans",
        meta: {
            title: "客户管理",
            icon: "el-icon-user",
            menuType: 'membership'
        },
        component: pageView,
        children: [{
            path: "/fans/list",
            name: "fansList",
            meta: {
                title: "客户列表",
                icon: "el-icon-setting",
                menuType: 'membership'
            },
            component: () =>
                import("../views/fans/list.vue"),
        }]
    }
];
const routes = [{
        path: "/index",
        name: "index",
        component: layout,
        children: menuRoutes
    },
    {
        path: "/",
        name: "landing",
        component: () =>
            import("../views/Landing.vue"),
    },
    {
        path: "/login",
        name: "login",
        component: () =>
            import("../views/login/index.vue"),
    },
    // H5移动端路由
    {
        path: "/mobile",
        name: "mobile",
        redirect: "/mobile/home"
    },
    {
        path: "/mobile/home",
        name: "mobileHome",
        component: () =>
            import("../views/mobile/Home.vue"),
    },
    {
        path: "/mobile/detail/:id?",
        name: "mobileDetail",
        component: () =>
            import("../views/mobile/Detail.vue"),
    },
    {
        path: "/mobile/detail-legacy/:id?",
        name: "mobileDetailLegacy",
        component: () =>
            import("../views/mobile/DetailLegacy.vue"),
    },
    {
        path: "/mobile/summary",
        name: "mobileSummary",
        component: () =>
            import("../views/mobile/Summary.vue"),
    },
    {
        path: "/mobile/movie-top",
        name: "mobileMovieTop",
        component: () =>
            import("../views/mobile/MovieTop.vue"),
    },
    // 公开访问路由（不需要登录）
    {
        path: "/public/tournament",
        name: "publicTournament",
        component: () =>
            import("../views/Tournament.vue"),
    },
]

const router = new VueRouter({
    //mode: 'history',
    base: process.env.BASE_URL,
    routes
})

// 添加路由守卫，进行全局用户识别
router.beforeEach(async (to, from, next) => {
    // 公开路由白名单，不需要登录验证
    const publicRoutes = ['/public/tournament', '/login', '/mobile/home', '/mobile/detail', '/mobile/detail-legacy', '/mobile/summary', '/mobile/movie-top'];
    // 根路径（落地页）也属于公开访问
    const isPublicRoute = to.path === '/' || publicRoutes.some(route => to.path.startsWith(route));
    
    // 进入非公开路由时检查 token（过期则 goLogin，并回到落地页而不是 abort 留在半截导航）
    console.log('[router beforeEach]', { to: to.path, from: from.path, isPublicRoute, tokenBefore: !!ApiService.getToken() })
    if (!isPublicRoute) {
        await ApiService.checkToken()
        const hasTokenAfter = !!ApiService.getToken()
        console.log('[router beforeEach] checkToken 后', { hasTokenAfter })
        if (!hasTokenAfter) {
            next({ path: '/', replace: true })
            return
        }
    }

    if (to.matched.some(record => record.meta && record.meta.requireAdmin)) {
        let userInfo = null
        try {
            userInfo = JSON.parse(localStorage.getItem("userInfo") || "null")
        } catch (e) {
            userInfo = null
        }
        if (!userInfo || userInfo.isAdmin !== true) {
            Message.error('无权限访问')
            next('/welcome')
            return
        }
    }
    
    // 全局 Mixpanel 用户识别：确保已登录用户被识别
    const userInfo = localStorage.getItem("userInfo");
    const mixpanelIdentified = sessionStorage.getItem("mixpanelIdentified");
    
    if (userInfo && !mixpanelIdentified && Vue.prototype.$mixpanel) {
        try {
            const user = JSON.parse(userInfo);
            Vue.prototype.$mixpanel.identify(user.userId);
            
            // 可选：同时设置用户属性（如果有完整信息）
            if (user.nickName) {
                const avatarUrl = user.avatarUrl 
                    ? user.avatarUrl.replace(/\/\/file\./g, '//tcdn.')
                    : '';
                    
                Vue.prototype.$mixpanel.people.set({
                    '$name': user.nickName,
                    '$avatar': avatarUrl,
                    'unionid': user.unionid,
                    'openid': user.openid
                });
            }
            
            // 标记已识别（使用 sessionStorage，关闭浏览器后重置）
            sessionStorage.setItem("mixpanelIdentified", "true");
            console.log('[Mixpanel] 全局识别用户:', user.userId);
        } catch (error) {
            console.error('[Mixpanel] 全局识别用户失败:', error);
        }
    }
    
    next();
});

// 添加路由后置守卫，追踪页面浏览
router.afterEach((to) => {
    if (Vue.prototype.$mixpanel) {
        try {
            Vue.prototype.$mixpanel.track('Page View', {
                'page_path': to.path,
                'page_name': to.name,
                'page_title': to.meta?.title || to.name
            });
        } catch (error) {
            console.error('[Mixpanel] 追踪失败:', error);
        }
    }
});

export default router